/**
 * Determines whether a status should be displayed.
 *
 * @param status - The status to check
 * @returns Whether the status should be shown
 */
export default function shouldShowStatus(status: unknown): boolean {
  if (!status || typeof status !== 'string') {
    return false;
  }
  return status !== 'Opened';
}
